import { OperationType } from '../types';

export function parseOperationType(queryString: string) {
  let type = '';
  let name = '';
  let hasType = false;

  for (let x = 0; x < queryString.length; x++) {
    let c = queryString.charAt(x);

    if (c === ' ') {
      hasType = true;
      continue;
    }

    if ((c === ' ' || c === '(' || c === '{') && hasType) {
      break;
    }

    if (!hasType) {
      type += c;
    } else {
      name += c;
    }
  }

  return { type: type as OperationType, name };
}
